﻿export class SearchProFunnelModel {
    page: number;
    limit: number;
    sortCol: string;
    sortType: number;
    culture: string;
    email: string;

    searchCompanyId: string;
    searchCompanyName: string;
    searchCompanyState: string;
    searchCompanyType: string;
    searchCompanyCountry: string;
    searchHiddenCompany: boolean;
    searchCompanyUrl: string;
    searchCompanyGrade: string;
    searchContactName: string;
    searchEmail: string;
    searchPhone: string;
    startDate?: Date;
    endDate?: Date;
}
